import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const checkRenewalsApi = createApi({
  reducerPath: 'checkRenewalsApi',
  baseQuery: createBaseQuery('check_renewals', { timeout: 200000 }),
  endpoints: builder => ({
    getCheckRenewals: builder.query({
      query: ({ params }) => `?${toQueryParams(params)}`,
      transformResponse: ({ result }) => result,
    }),
    updateCheckRenewal: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    renewCheckRenewal: builder.mutation({
      query: id => ({
        url: `/${id}/renew`,
        method: 'POST',
      }),
      transformResponse: ({ result }) => result,
    }),
    getCheckRenewalsForCandidate: builder.query({
      query: ({ candidateId }) => `/candidate/${candidateId}`,
      transformResponse: ({ result }) => result,
    }),
    createCheckRenewalsFromConfig: builder.mutation({
      query: ({ employeeId, data }) => ({
        url: `/employee/${employeeId}`,
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    createChecksRenewalsForEmployee: builder.mutation({
      query: ({ employeeId, data }) => ({
        url: `/employee/${employeeId}/bulk`,
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    bulkRenewCheckRenewals: builder.mutation({
      query: data => ({
        url: '/bulk/renew',
        method: 'POST',
        body: data,
      }),
    }),
    bulkRemindCheckRenewals: builder.mutation({
      query: data => ({
        url: '/bulk/reminder',
        method: 'POST',
        body: data,
      }),
    }),
    bulkUpdateCheckRenewals: builder.mutation({
      query: data => ({
        url: '/bulk',
        method: 'PUT',
        body: data,
      }),
    }),
  }),
});

export const {
  useLazyGetCheckRenewalsQuery,
  useUpdateCheckRenewalMutation,
  useRenewCheckRenewalMutation,
  useBulkRenewCheckRenewalsMutation,
  useBulkRemindCheckRenewalsMutation,
  useBulkUpdateCheckRenewalsMutation,
  useGetCheckRenewalsForCandidateQuery,
  useCreateCheckRenewalsFromConfigMutation,
  useCreateChecksRenewalsForEmployeeMutation,
} = checkRenewalsApi;
